import React from 'react';

/** Drop-Ziele liegen in der Sidebar; Tray bleibt als No-Op für Kompatibilität. */
const MailDropTray = () => null;

export default MailDropTray;
